let apidaePrestas = {
    delimiters: ['%%', '%%'],
    components: {
        apidaePrestasSearch,
        apidaePrestasListe        
    },
    props: {
        title: String,
        type: String,
        prestaItems: Array,
        lang: String,
        showDate: Number,
        showTarif: Number,
        showFiltre: Number,
        showFiltreDate: Number,
        showFiltreAge: Number,
        showFiltrePrice: Number,
        showFiltreCapacity: Number,
        showFiltreNombreChambres: Number,
        showFiltreNombreJours: Number,
        showFiltreNombreNuits: Number,
        showFiltreDistance: Number,
        showFiltreDuration: Number,
        showFiltreElevation: Number,
        nbPrestas: Number,
        params: Object,
        groupesFiltres: Array,
        pmin: Number,
        pmax: Number,
        njmin: Number,
        njmax: Number
    },
    template: `
        <div class="Prestas">
            <h2 class="h2" v-if="title">%% title %%</h2>
            <div v-if="showFiltre" class="TopBar__headline"><span class="number">%% nbPrestas %%</span> résultats</div>
            <apidae-prestas-search v-if="showFiltre" :params="params" :groupes-filtres="groupesFiltres" :nb-prestas="nbPrestas" :pmin="pmin" :pmax="pmax" :njmin="njmin" :njmax="njmax" :type="type" :title="title" :lang="lang" :show-tarif="showTarif" :show-filtre="showFiltre" :show-filtre-age="showFiltreAge" :show-filtre-date="showFiltreDate" :show-filtre-price="showFiltrePrice" :show-filtre-capacity="showFiltreCapacity" :show-filtre-nombre-chambres="showFiltreNombreChambres" :show-filtre-nombre-jours="showFiltreNombreJours" :show-filtre-nombre-nuits="showFiltreNombreNuits" :show-filtre-distance="showFiltreDistance" :show-filtre-duration="showFiltreDuration" :show-filtre-elevation="showFiltreElevation" />
            <apidae-prestas-liste :presta-items="prestaItems" :lang="lang" :type="type" :show-date="showDate" :show-tarif="showTarif" />
        </div>`
};

if (document.querySelector('.prestaItems')) {
    document.querySelectorAll('.prestaItems').forEach(i => {
        let id = i.getAttribute('id');
        let uri = i.dataset.url;
        let title = i.dataset.title;
        let type = i.dataset.type;
        let nb = i.dataset.nb;
        let lang = i.dataset.lang;
        let showDate = parseInt(i.dataset.showdate);
        let showTarif = parseInt(i.dataset.showtarif);
        let showFiltre = parseInt(i.dataset.showfiltre);
        let showFiltreDate= parseInt(i.dataset.showfiltredate);
        let showFiltreAge= parseInt(i.dataset.showfiltreage);
        let showFiltrePrice = parseInt(i.dataset.showfiltreprice);
        let showFiltreCapacity = parseInt(i.dataset.showfiltrecapacity);
        let showFiltreNombreChambres = parseInt(i.dataset.showfiltrenombrechambres);
        let showFiltreNombreJours = parseInt(i.dataset.showfiltrenombrejours);
        let showFiltreNombreNuits = parseInt(i.dataset.showfiltrenombrenuits);
        let showFiltreDistance = parseInt(i.dataset.showfiltredistance);
        let showFiltreDuration = parseInt(i.dataset.showfiltreduration);
        let showFiltreElevation = parseInt(i.dataset.showfiltreelevation);
        let filter = i.dataset.filter;
        let searchParams = new URLSearchParams(window.location.search);

        new Vue({
            delimiters: ['%%', '%%'],
            el: '#' + id,
            components: { 
                apidaePrestas
            },
            data: function () {
                return {
                    loading: true,
                    query: '?' + searchParams.toString(),
                    title: title,
                    type: type,
                    prestaItems: [],
                    lang: lang,
                    showDate: showDate,
                    showTarif: showTarif,
                    showFiltre: showFiltre,
                    showFiltreAge: showFiltreAge,
                    showFiltreDate: showFiltreDate,
                    showFiltrePrice: showFiltrePrice,
                    showFiltreCapacity: showFiltreCapacity,
                    showFiltreNombreChambres: showFiltreNombreChambres,
                    showFiltreNombreJours: showFiltreNombreJours,
                    showFiltreNombreNuits: showFiltreNombreNuits,
                    showFiltreDistance: showFiltreDistance,
                    showFiltreDuration: showFiltreDuration,
                    showFiltreElevation: showFiltreElevation,
                    nbPrestas: 0,
                    params: {},
                    groupesFiltres: [],
                    pmin: 0,
                    pmax: 10000,
                    njmin: 0,
                    njmax: 8
                }
            },
            mounted: function() {
                fetch(apidae.site_url + uri + '/json' + this.query)
                .then(stream => stream.json())
                .then(data => {
                    this.params = data.params;
                    this.nbPrestas = data.items.length;
                    this.groupesFiltres = data.filtres;

                    this.prestaItems = data.items.slice(0, nb);
                    // console.log(this.prestaItems);

                    this.loading = false;
                    
                    if(type == 'slide' && type != 'grid'){
                        imagesLoaded(this, function() {
                            jQuery('#' + id + ' .slider-prestaList').owlCarousel({
                                loop: false,
                                margin: 20,
                                nav: true,
                                dots: false,
                                navText: ['<i class="fal fa-long-arrow-left"></i>', '<i class="fal fa-long-arrow-right"></i>'],
                                responsive: {
                                    0: {
                                        items: 1
                                    },
                                    600: {
                                        items: 2
                                    },
                                    800: {
                                        items: 3
                                    },
                                    1000: {
                                        items: 4
                                    }
                                }
                            });
                        });
                    }
                })
                .catch(error => console.error(error))
            },
            methods: {
                callfilters: function(event) {
                    // console.log(event);
                    let apiUrl = apidae.site_url + uri + '/json';
                    let query = '?tri=triEvenement&searchByMap=0&zl=&slt=&slg=&nlt=&nlg=';

                    if (event.target.classList.contains('pricevent')) {
                        this.pmin = Number(event.target.getAttribute('data-pmin'))
                        this.pmax = Number(event.target.getAttribute('data-pmax'))
                    }
                    query += '&pmin=' + this.pmin + '&pmax=' + this.pmax;

                    if (event.target.classList.contains('nombrejoursevent')) {
                        this.njmin = Number(event.target.getAttribute('data-njmin'))
                        this.njmax = Number(event.target.getAttribute('data-njmax'))
                    }
                    query += '&njmin=' + this.njmin + '&njmax=' + this.njmax;

                    if (showFiltreDate) {
                        query += '&rbl=calendar&dd=' + this.params.dateDebut + '&df=' + this.params.dateFin;
                    }

                    // console.log(this.groupesFiltres);
                    let cgroupesFiltres = this.groupesFiltres;
                    cgroupesFiltres.forEach(cgroupefiltres => {
                        let cfiltres = cgroupefiltres.listeFiltre;
                        cfiltres.forEach(cfiltre => {
                            // console.log(cfiltre.selected);
                            if (cfiltre.selected) {
                                // console.log(cfiltre.idFiltre);
                                query += '&filter' + cfiltre.idFiltre + '=' + cgroupefiltres.idGroupe;
                            }
                        });
                    });
                    // console.log(cgroupesFiltres);
                    // console.log(query);

                    fetch(apiUrl + query)
                        .then(stream => stream.json())
                        .then(data => {
                            this.nbPrestas = data.items.length;
                            this.groupesFiltres = data.filtres;
                            this.prestaItems = data.items.slice(0, nb);
                        })
                        .catch(error => console.error(error))
                },
                // submitfilters: function(event) {
                //     let query =  uri + '?tri=triEvenement&searchByMap=0&zl=&slt=&slg=&nlt=&nlg=&njmin=0&njmax=8&pmin=' + this.pmin + '&pmax=' + this.pmax;
                //     let cgroupesFiltres = this.groupesFiltres;
                //     cgroupesFiltres.forEach(cgroupefiltres => {
                //         let cfiltres = cgroupefiltres.listeFiltre;
                //         cfiltres.forEach(cfiltre => {
                //             // console.log(cfiltre.selected);
                //             if (cfiltre.selected) {
                //                 console.log(cfiltre.idFiltre);
                //                 query += '&filter' + cfiltre.idFiltre + '=' + cgroupefiltres.idGroupe;
                //             }
                //         });
                //     });
                //     // console.log(apidae.site_url + uri);
                //     window.location = apidae.site_url + query;
                // }
            }
        });
    });
}
